import { useParams } from "react-router-dom"
import { useGetTasks } from "../api/task/task.ts"
import { Task, TaskDefinition, TaskStatus } from "../backend/types/task.ts"
import { useMemo } from "react"

export const useTracingStatuses = () => {
    const { documentId } = useParams()
    const { data: moneyFlowTasks, isLoading: isTasksLoading } = useGetTasks(documentId ? { documentId } : undefined)

    function getTasksStatuses(moneyFlowTasks: Task[] | undefined, isTasksLoading: boolean) {
        let isAutoTracing = false
        let isTracingRunning = false
        let isAutoTracingCompleted = false

        if (moneyFlowTasks?.length) {
            const currentTask = moneyFlowTasks[0]

            switch (currentTask.status) {
            case TaskStatus.Running:
            case TaskStatus.Queued: {
                isTracingRunning = true
                if (currentTask.type === TaskDefinition.Autotrace) {
                    isAutoTracing = true
                }
                break
            }
            case TaskStatus.Completed: {
                if (currentTask.type === TaskDefinition.Autotrace) {
                    isAutoTracingCompleted = true
                }
                break
            }
            case TaskStatus.Cancelled:
            case TaskStatus.Failed: {
                isAutoTracing = false
                isTracingRunning = false
                isAutoTracingCompleted = false
            }
            }
        }

        return {
            isTasksLoading,
            isTracingRunning,
            isAutoTracing,
            isAutoTracingCompleted
        }
    }

    const moneyFlowInTasks = useMemo(() => moneyFlowTasks?.filter(
        (task) => (task.type === TaskDefinition.Trace || task.type === TaskDefinition.Autotrace) &&
            task.args.direction === 'in'
    ), [moneyFlowTasks])
    const moneyFlowOutTasks = useMemo(() =>  moneyFlowTasks?.filter(
        (task) => (task.type === TaskDefinition.Trace || task.type === TaskDefinition.Autotrace) &&
            task.args.direction === 'out'
    ), [moneyFlowTasks])
    const In = useMemo(() => getTasksStatuses(moneyFlowInTasks, isTasksLoading), [isTasksLoading, moneyFlowInTasks])
    const Out = useMemo(() => getTasksStatuses(moneyFlowOutTasks, isTasksLoading), [isTasksLoading, moneyFlowOutTasks])

    return { In, Out }
}
